import { TNavItem } from "./types";

export const navItems: { [fieldName: string]: TNavItem } = {
  home: {
    to: "/",
    label: "Home",
  },
  tickets: {
    to: "/tickets",
    label: "Tickets",
  },
  festivalInfo: {
    to: "/festival-information",
    label: "Festival Info",
  },
  getinvolved: {
    to: "/get-involved",
    label: "Get Involved",
  },
  lineup: {
    to: "/lineup",
    label: "Lineup",
  },
  terms: {
    to: "/toc",
    label: "terms",
  },
};
